import { render } from "./BaseRadioGroup.vue?vue&type=template&id=922d3a0c&scoped=true"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js"

import "./BaseRadioGroup.vue?vue&type=style&index=0&id=922d3a0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-922d3a0c"

export default script